// THE ONE PALETTE for drawn art in both apps (founder 2026-09-30, the Monzo
// "Suggested for you" look): flat, layered, rounded objects in a multi colour
// pastel set, with a dark ink layer peeking out behind a lighter one for depth.
// No outlines, no gradients. Plain JS so the worker and the Hub can both read
// it (the Hub still keeps its own copy in practice/components/art/pastel.js;
// pointing it here is a later cleanup).
//
// ⛔ Art only. These are not UI tokens: never use them for text, buttons or
// status. No turquoise here (turquoise is the logo), no link blue (blue is for
// actions).
//
// Two ink roles:
//   ink    small details drawn ON a pastel face (a clock hand, a tick, a £).
//          Navy in both schemes, because it always sits on a light colour.
//   depth  the offset layer UNDER an object. Navy on a light screen; in dark it
//          lifts to a slate indigo, or the shadow would vanish into the surface.
const BASE = {
  pink: '#FF4FA0',
  softPink: '#FFB3D6',
  yellow: '#FFD54A',
  lime: '#B5E36A',
  mint: '#7FE0C2',
  green: '#22B08A',
  coral: '#FF7A57',
  lavender: '#A9A3FF',
  ink: '#14213D',
  white: '#FFFFFF',
}

export const PASTEL_TONES = {
  light: { ...BASE, depth: BASE.ink },
  dark: { ...BASE, depth: '#46558A' },
}
